import { render } from "./editBlague.vue?vue&type=template&id=5c212f3f"
import script from "./editBlague.vue?vue&type=script&lang=js"
export * from "./editBlague.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__